// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2gui3","noInteraction":"EventWrapper_noInteraction__10kXv","pointerPassthrough":"EventWrapper_pointerPassthrough__2za8A"};